import notificationsIcon from "../icons/notifications.png";


export const NotificationCard = (props) => {
    return (
        <div className="container-fluid py-1 w-100">
            <div className="row align-items-center justify-content-center">
                <div className="col-sm-2">
                    <img className="mr-1" src={notificationsIcon} />

                </div>
                <div className="col-sm-10 text-left">
                    <span className="w-100">{props.notification}</span>
                </div>
            </div>
        </div>
    )
}